'use client';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div`
  font-size: 0.9rem;
  letter-spacing: 1px;
`;

export const LogoContainer = styled.div`
  padding: 0 5%;
`;
